var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import '@bit/smartworks.unity.unity-core/unity-table';
const slotStyles = {
    flex: 1,
    minHeight: 'var(--trow-height)',
    display: 'flex',
    alignItems: 'center',
    maxWidth: '100%'
};
export default class UnityTable extends Component {
    constructor() {
        super(...arguments);
        this.tableRef = React.createRef();
        this.componentDidMount = () => {
            this.updateProperties();
        };
        this._slotIdExtractor = (row, column) => {
            const { keyExtractor = () => { } } = this.props;
            const rowId = keyExtractor(row);
            return `${rowId}-${column.key}`;
        };
        this.renderCustomContent = () => {
            const { data = [], columns = [], childKeys = [], } = this.props;
            let slots = [];
            let nodes = [...data];
            const colsWithContent = columns.filter(({ renderCustomContent } = {}) => renderCustomContent instanceof Function);
            const accumulateNodes = (node) => (childKey = '') => {
                const children = node[childKey];
                if (Array.isArray(children)) {
                    nodes = [...nodes, ...children];
                }
                return nodes;
            };
            for (let i = 0; i < nodes.length; i++) {
                const node = nodes[i];
                childKeys.forEach(accumulateNodes(node));
            }
            nodes.forEach((node = {}) => {
                colsWithContent.forEach((column = {}) => {
                    const { key = '', renderCustomContent = () => (React.createElement(React.Fragment, null)) } = column;
                    const cellValue = node[key];
                    const customContent = renderCustomContent(cellValue, node);
                    const slotId = this._slotIdExtractor(node, column);
                    if (!!customContent) {
                        slots.push(React.createElement("div", { slot: slotId, key: slotId, style: slotStyles }, customContent));
                    }
                });
            });
            return slots;
        };
        this.renderRightActionsContent = () => {
            const { rightActionsContent } = this.props;
            if (!!rightActionsContent) {
                return React.createElement("div", { slot: "right-actions" }, rightActionsContent);
            }
        };
    }
    componentDidUpdate(oldProps) {
        this.updateProperties(oldProps);
    }
    updateProperties(oldProps = {}) {
        const { data, columns, selected, childKeys, keyExtractor, slotIdExtractor, onClickRow, onSelectionChange, onDisplayColumnsChange, onColumnChange, onEndReached, onHighlight, onExpandedChange, columnFilter } = this.props;
        const { data: oldData, columns: oldColumns, selected: oldSelected, childKeys: oldChildKeys, keyExtractor: oldKeyExtractor, slotIdExtractor: oldSlotIdExtractor, onClickRow: oldOnClickRow, onSelectionChange: oldOnSelectionChange, onDisplayColumnsChange: oldOnDisplayColumnsChange, onColumnChange: oldOnColumnChange, onEndReached: oldOnEndReached, onHighlight: oldOnHighlight, onExpandedChange: oldOnExpandedChange, columnFilter: oldColumnFilter } = oldProps;
        const unityTable = this.tableRef.current;
        if (unityTable) {
            if (oldChildKeys !== childKeys) {
                unityTable.childKeys = childKeys;
            }
            if (oldColumns !== columns) {
                unityTable.columns = columns;
            }
            if (oldSelected !== selected) {
                unityTable.selected = selected;
            }
            if (oldData !== data) {
                unityTable.data = data;
            }
            if (oldKeyExtractor !== keyExtractor) {
                unityTable.keyExtractor = keyExtractor;
            }
            if (oldSlotIdExtractor !== slotIdExtractor) {
                unityTable.slotIdExtractor = slotIdExtractor;
            }
            if (oldOnClickRow !== onClickRow) {
                unityTable.onClickRow = onClickRow;
            }
            if (oldOnSelectionChange !== onSelectionChange) {
                unityTable.onSelectionChange = onSelectionChange;
            }
            if (oldOnDisplayColumnsChange !== onDisplayColumnsChange) {
                unityTable.onDisplayColumnsChange = onDisplayColumnsChange;
            }
            if (oldOnColumnChange !== onColumnChange) {
                unityTable.onColumnChange = onColumnChange;
            }
            if (oldOnEndReached !== onEndReached) {
                unityTable.onEndReached = onEndReached;
            }
            if (oldOnHighlight !== onHighlight) {
                unityTable.onHighlight = onHighlight;
            }
            if (oldSlotIdExtractor !== slotIdExtractor) {
                unityTable.slotIdExtractor = slotIdExtractor;
            }
            if (oldOnExpandedChange !== onExpandedChange) {
                unityTable.onExpandedChange = onExpandedChange;
            }
            if (oldColumnFilter !== columnFilter) {
                unityTable.columnFilter = columnFilter;
            }
        }
    }
    render() {
        const _a = this.props, { selectable = false, filter = '', emptyText, isLoading = false, children, highlightedRow = '', endReachedThreshold = 200, compact, headless, startExpanded, disableColumnResize, hideFilterIcons, style, data, columns, selected, childKeys, keyExtractor, slotIdExtractor, onClickRow, onSelectionChange, onDisplayColumnsChange, onColumnChange, onEndReached, onHighlight, onExpandedChange, columnFilter, rightActionsContent } = _a, otherProps = __rest(_a, ["selectable", "filter", "emptyText", "isLoading", "children", "highlightedRow", "endReachedThreshold", "compact", "headless", "startExpanded", "disableColumnResize", "hideFilterIcons", "style", "data", "columns", "selected", "childKeys", "keyExtractor", "slotIdExtractor", "onClickRow", "onSelectionChange", "onDisplayColumnsChange", "onColumnChange", "onEndReached", "onHighlight", "onExpandedChange", "columnFilter", "rightActionsContent"]);
        let booleanProps = {};
        if (isLoading) {
            booleanProps.isLoading = isLoading;
        }
        if (selectable) {
            booleanProps.selectable = selectable;
        }
        if (compact) {
            booleanProps.compact = compact;
        }
        if (headless) {
            booleanProps.headless = headless;
        }
        if (startExpanded) {
            booleanProps.startExpanded = startExpanded;
        }
        if (disableColumnResize) {
            booleanProps.disableColumnResize = disableColumnResize;
        }
        if (hideFilterIcons) {
            booleanProps.hideFilterIcons = hideFilterIcons;
        }
        return (React.createElement("unity-table", Object.assign({ ref: this.tableRef, filter: filter, emptyDisplay: emptyText, highlightedRow: highlightedRow, endReachedThreshold: endReachedThreshold, style: style }, booleanProps, otherProps),
            this.renderCustomContent(),
            this.renderRightActionsContent(),
            children));
    }
}
